import styled from 'styled-components'

const COLUMN_COUNT = 7

export const EvenTableWrapper = styled.div`
  width: 100%;

  table {
    table-layout: fixed;
    width: 100%;
  }

  th,
  td {
    width: ${100 / COLUMN_COUNT}%;
    overflow: hidden;
  }
`

export const EvenCell = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.2rem;
  width: 100%;
  min-height: 2.5rem;
  justify-content: center;
`
